import axiosInstance from "../axiosInstance";

export const registerCandidate = (candidateData) => {
  return axiosInstance.post("/user/register/candidate", candidateData);
};

export const fetchCandidateRequestData = () => {
  return axiosInstance.get("/user/candidate-request-data");
};


export const fetchTotalCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/total-candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
  });
};

export const fetchLoginExpiredCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/loginExpired/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
    withCredentials: true,
  });
};

export const fetchBgvInProgressCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/inProgress/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
  });
};

export const fetchSubmittedCandidates = async (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/submit/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
  });
};

export const fetchReadyForBgcCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/readyForBgc/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
  });
};

export const fetchBgvCompletedCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/bgvCompleted/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
    withCredentials: true,
  });
};

export const fetchUserCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/pending/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
    withCredentials: true,
  });
};

export const fetchpendingsubmissionCandidates = (
  page = 0,
  size = 10,
  search = "",
  sortField = "createddate",
  sortDir = "desc",
) => {
  return axiosInstance.get("/user/nonSubmit/candidates", {
    params: {
      page,
      size,
      search,
      sortField,
      sortDir,
    },
    withCredentials: true,
  });
};

export const fetchUserDashboardData = () => {
  return axiosInstance.get("/user/home");
};

export const fetchUserProfile = () => {
  return axiosInstance.get("/user/user/profile");
};

export const updatePhoneNumber = (mobileNo, email) => {
  return axiosInstance.put(`/user/updatePhoneNumber/${mobileNo}/${email}`);
};

export const startCandidateBGC = (candidateId) => {
  return axiosInstance.post(`/user/start-bgc`, null, {
    params: { candidateId },
  });
};

export const fetchRecentCandidates = (page = 0, size = 10) => {
  return axiosInstance.get("/user/recent", {
    params: {
      page,
      size,
    },
  });
};

export const fetchCandidateInfo = (candidateId, page = 0, size = 10) => {
  return axiosInstance.get(`/user/candidateInfo/${candidateId}`, {
    params: {
      page,
      size,
    },
  });
};

export const restoreCandidate = (candidateId) => {
  return axiosInstance.post(`/user/refresh-candidate/${candidateId}`);
};

export const softDeleteCandidate = (candidateId) => {
  return axiosInstance.put(`/user/soft-delete/${candidateId}`);
};

export const fetchFullCandidateReport = (candidateId) => {
  return axiosInstance.get(`/user/candidate-verification/${candidateId}`);
};

export const downloadReport = async (candidateId) => {
  const response = await axiosInstance.get(`/user/generate/${candidateId}`, {
    responseType: "blob",
  });
  return response.data;
};

export const confirmUserAccount = (token) => {
  return axiosInstance.get(`/user/confirm-account`, {
    params: { token },
  });
};

// ================= NOTIFICATIONS =================

export const fetchNotifications = async () => {
  const res = await axiosInstance.get("/user/notifications");
  return res.data.data;
};

export const fetchUnreadCount = async () => {
  const res = await axiosInstance.get("/user/notifications/unread-count");
  return res.data.data;
};

export const approveRequest = (updateRequest) => {
  return axiosInstance.put("/user/approve", updateRequest);
};

export const rejectRequest = (updateRequest) => {
  return axiosInstance.put("/user/reject", updateRequest);
};

export const markAllNotificationsAsRead = () => {
  return axiosInstance.put("/user/notifications/mark-all-read");
};

export const markNotificationAsRead = (id) => {
  return axiosInstance.put(`/user/notifications/${id}/read`);
};

// for the activity feed.
export const fetchActivityFeed = () => {
  return axiosInstance.get("/user/activity/feed");
};

export const validateWalletBalance = (data) => {
  return axiosInstance.post("/payment/wallet/validate", data);
};

export const deductWalletAmount = (data) => {
  return axiosInstance.post("/payment/wallet/deduct", data);
};
export const getClientPricing = () => {
  return axiosInstance.get("/payment/pricing/view-list");
};


// for the notification delete service . 
export const deleteNotificationById = async (id) => {
  return axiosInstance.delete(`/user/notification/delete?id=${id}`);
};

export const deleteAllReadNotifications = async () => {
  return axiosInstance.delete("/user/notification/delete/all");
};

export const fetchEmploymentChecks = (candidateId) => {
  return axiosInstance.get(`/api/employee/get/employment/${candidateId}`);
};

export const fetchVirtualEmploymentChecks = (candidateId) => {
  return axiosInstance.get(`/api/employee/get/employmentVirtual/${candidateId}`);
};